// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2-oC09NVp2","link":"_1_08_j4zL7","version":"_3Y-eAx64y2","documentation":"_1C7Ma8lfGZ","claim":"_3TfATghkGx","right":"_3OB9ffI28H"};
    if(module.hot) {
      // 1614934679514
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  